import React, { useEffect } from 'react';
import { Button, Form, Input, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const AdminUserForm = ({ handleSubmit, action, user, handleCancel, isFetching }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('auth');
  const { t: tc } = useTranslation('common');

  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(values);
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue({ giveName: null, familyName: null, email: null, password: null });
    } else if (user) {
      // Split user.name into giveName and familyName for the form
      const nameParts = (user.name || '').split(' ');
      const giveName = nameParts[0] || '';
      const familyName = nameParts.slice(1).join(' ') || '';
      form.setFieldsValue({
        giveName,
        familyName,
        email: user.email,
      });
    }
  }, [action, user]);

  return (
    <Spin spinning={isFetching}>
      <div className="RiderForm">
        <div className="FormHeader"></div>
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            onFinish={onFinishForm}
          >
            <Form.Item label={t('firstName')} name="giveName" rules={[{ required: true, message: tc('required') }]}>
              <Input placeholder={t('firstName')} />
            </Form.Item>
            <Form.Item label={t('lastName')} name="familyName" rules={[{ required: true, message: tc('required') }]}>
              <Input placeholder={t('lastName')} />
            </Form.Item>
            <Form.Item
              label={t('email')}
              name="email"
              rules={[
                { required: true, message: tc('required') },
                { type: 'email', message: tc('invalidEmail') },
              ]}
            >
              <Input placeholder={t('email')} />
            </Form.Item>
            <Form.Item
              label={tc('password')}
              name="password"
              rules={[{ required: action === 'new', message: tc('required') }]}
            >
              <Input.Password
                placeholder={action === 'new' ? t('passwordPlaceholder') : t('passwordKeepCurrent')}
                autoComplete="new-password"
              />
            </Form.Item>
          </Form>
        </div>
        <div className="FormFooter">
          <Button key="cancel" onClick={handleCancel}>
            {tc('cancel')}
          </Button>
          <Button type="primary" block size="large" onClick={() => form.submit()}>
            {action === 'new' ? tc('create') : tc('update')}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default AdminUserForm;
